<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Edit Auto Payments
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <template v-if="pageReady">
                                        <div class="grid">
                                            <div class="col-12">
                                                <form ref="observer"  tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                                    <!--[form-content-start]-->
                                                    <div class="grid">
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Account Number 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlaccount_number" v-model.trim="formData.account_number"  label="Account Number" type="text" placeholder="Enter Account Number"      
                                                                    class=" w-full" :class="getErrorClass('account_number')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('account_number')" class="p-error">{{ getFieldError('account_number') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Customer Name 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlcustomer_name" v-model.trim="formData.customer_name"  label="Customer Name" type="text" placeholder="Enter Customer Name"      
                                                                    class=" w-full" :class="getErrorClass('customer_name')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('customer_name')" class="p-error">{{ getFieldError('customer_name') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Customer Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlcustomer_id" v-model.trim="formData.customer_id"  label="Customer Id" type="number" placeholder="Enter Customer Id"   step="any"    
                                                                    class=" w-full" :class="getErrorClass('customer_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Last Bill Amount 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrllast_bill_amount" v-model.trim="formData.last_bill_amount"  label="Last Bill Amount" type="number" placeholder="Enter Last Bill Amount"   step="0.1"    
                                                                    class=" w-full" :class="getErrorClass('last_bill_amount')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('last_bill_amount')" class="p-error">{{ getFieldError('last_bill_amount') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Last Bill Date 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <Calendar :showButtonBar="true" :showTime="true" dateFormat="yy-mm-dd" hourFormat="24" v-model="formData.last_bill_date" :showIcon="true" class="w-full" :class="getErrorClass('last_bill_date')"     mask="yy-MM-DD HH:mm"     />
                                                                    <small v-if="isFieldValid('last_bill_date')" class="p-error">{{ getFieldError('last_bill_date') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Msisdn 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlmsisdn" v-model.trim="formData.msisdn"  label="Msisdn" type="text" placeholder="Enter Msisdn"      
                                                                    class=" w-full" :class="getErrorClass('msisdn')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('msisdn')" class="p-error">{{ getFieldError('msisdn') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Network 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlnetwork" v-model.trim="formData.network"  label="Network" type="text" placeholder="Enter Network"      
                                                                    class=" w-full" :class="getErrorClass('network')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('network')" class="p-error">{{ getFieldError('network') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Client Request Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrlclient_request_id" v-model.trim="formData.client_request_id"  label="Client Request Id" type="text" placeholder="Enter Client Request Id"      
                                                                    class=" w-full" :class="getErrorClass('client_request_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('client_request_id')" class="p-error">{{ getFieldError('client_request_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="formgrid grid">
                                                                <div class="col-12 md:col-3">
                                                                    Transaction Id 
                                                                </div>
                                                                <div class="col-12 md:col-9">
                                                                    <InputText ref="ctrltransaction_id" v-model.trim="formData.transaction_id"  label="Transaction Id" type="text" placeholder="Enter Transaction Id"      
                                                                    class=" w-full" :class="getErrorClass('transaction_id')">
                                                                    </InputText>
                                                                    <small v-if="isFieldValid('transaction_id')" class="p-error">{{ getFieldError('transaction_id') }}</small> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--[form-content-end]-->
                                                    <div v-if="showSubmitButton" class="text-center my-3">
                                                        <Button type="submit" label="Update" icon="pi pi-send" :loading="saving" />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="loading">
                                        <div class="p-3 text-center">
                                            <ProgressSpinner style="width:50px;height:50px" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useEditPage } from '@/composables/editpage.js';
	const props = defineProps({
		id: [String, Number],
		pageName: {
			type: String,
			default: 'auto_payments',
		},
		routeName: {
			type: String,
			default: 'auto_paymentsedit',
		},
		pagePath: {
			type : String,
			default : 'auto_payments/edit',
		},
		apiPath: {
			type: String,
			default: 'auto_payments/edit',
		},
		submitButtonLabel: {
			type: String,
			default: "Update",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterUpdate: {
			type: String,
			default: "Record updated successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
	});
	const app = useApp();
	const formDefaultValues = Object.assign({
		account_number: "", 
		customer_name: "", 
		customer_id: "", 
		last_bill_amount: "", 
		last_bill_date: "", 
		msisdn: "", 
		network: "", 
		client_request_id: "", 
		transaction_id: "", 
	}, props.pageData);
	const formData = reactive({ ...formDefaultValues });
	function onFormSubmited(response) {
		app.flashMsg(props.msgAfterUpdate);
		if(props.redirect) app.navigateTo(`/auto_payments`);
	}
	const rules = computed(() => {
		return {
			account_number: {  },
			customer_name: {  },
			customer_id: { numeric },
			last_bill_amount: { numeric },
			last_bill_date: {  },
			msisdn: {  },
			network: {  },
			client_request_id: {  },
			transaction_id: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); //form validation
	const page = useEditPage(props, formData, v$, onFormSubmited);
	//page state
	const {
		submitted, // form api submitted state - Boolean
		saving, // form api submiting state - Boolean
		loading, // form data loading state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page computed propties
	const {
		apiUrl, // page current api path
		currentRecord, // current page record  - Object
	} = page.computedProps
	//page methods
	const { 
		load, // get editable form data from api
		submitForm, // submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Edit Auto Payments";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
		load();
	});
</script>
<style scoped>
</style>
